/* 新版商品页（sections/kx-product.liquid）：
   - 「感谢订阅」那条：只有刚在 Klaviyo 表单里留了邮箱的人看得到（ks-attribution 在提交时写 sessionStorage 的 ks_sub），
     看过一次就清掉 —— 刷新或下次再来不会还在谢；
   - 按钮：把这件商品在购物车里的数量设成 1（一人一份订金，连点两次也不会变 2），挂上来源记录，直接去结账。
     哪一步失败就退回表单本来的提交（加购 + return_to=/checkout），不会卡住人；
   - 按钮上方确认邮箱（emailBox）：亮出要预填进结账页的邮箱、能改，域名疑似打错提示一句；
   - 左边的图片浏览器（pdp-gallery）：横向滚动吸附是浏览器自己的（手指 / 触控板），这里补鼠标拖、前后按钮、方向键、
     缩略图跟随、放大看（同一套逻辑跑在弹出层那条上）。 */
(() => {
  // 一条横向吸附的轨道：idx 跟着滚动走；go() 是代码翻页（翻的途中不让经过的几张把缩略图闪一遍）
  function rig(track, prev, next, onChange) {
    const n = track.children.length;
    const w = () => track.clientWidth || 1;
    let idx = -1, aim = -1, raf = 0;
    const set = (i) => {
      if (i === idx) return;
      idx = i;
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= n - 1;
      onChange && onChange(i);
    };
    const go = (i, instant) => {
      i = KX.clamp(i, 0, n - 1);
      aim = i;
      track.scrollTo({ left: i * w(), behavior: instant || KX.reduce() ? 'auto' : 'smooth' });
      set(i);
    };
    track.addEventListener('scroll', () => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        raf = 0;
        if (aim >= 0) { if (Math.abs(track.scrollLeft - aim * w()) > 2) return; aim = -1; }
        set(Math.round(track.scrollLeft / w()));
      });
    }, { passive: true });
    ['pointerdown', 'wheel', 'touchstart'].forEach((t) => track.addEventListener(t, () => { aim = -1; }, { passive: true }));
    prev?.addEventListener('click', () => go(idx - 1));
    next?.addEventListener('click', () => go(idx + 1));
    track.addEventListener('keydown', (e) => {
      const k = { ArrowLeft: idx - 1, ArrowRight: idx + 1, Home: 0, End: n - 1 }[e.key];
      if (k === undefined) return;
      e.preventDefault();
      go(k);
    });
    // 换了宽度（转屏 / 拖窗口）还停在同一张
    new ResizeObserver(() => { if (idx >= 0) track.scrollLeft = idx * w(); }).observe(track);

    // 鼠标拖：拖的时候关掉吸附、跟手走，松开后按方向翻一张（拖不到 40px 算没翻）；拖过就不算点击
    let drag = null, dragged = false;
    track.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse' || e.button !== 0 || n < 2) return;
      drag = { x: e.clientX, left: track.scrollLeft, id: e.pointerId };
      dragged = false;
    });
    track.addEventListener('pointermove', (e) => {
      if (!drag) return;
      const dx = e.clientX - drag.x;
      if (!dragged) {
        if (Math.abs(dx) < 6) return;
        dragged = true;
        track.setPointerCapture(drag.id);
        track.classList.add('is-drag');
      }
      track.scrollLeft = drag.left - dx;
    });
    const end = (e) => {
      if (!drag) return;
      const d = drag;
      drag = null;
      if (!dragged) return;
      const dx = e.clientX - d.x;
      const release = () => track.classList.remove('is-drag');
      go(Math.round(d.left / w()) + (dx < -40 ? 1 : dx > 40 ? -1 : 0));
      // 吸附等翻完再打开，不然半路就被吸回去
      if ('onscrollend' in window) track.addEventListener('scrollend', release, { once: true });
      setTimeout(release, 700);
    };
    track.addEventListener('pointerup', end);
    track.addEventListener('pointercancel', end);
    track.addEventListener('click', (e) => { if (dragged) { e.preventDefault(); e.stopPropagation(); dragged = false; } }, true);
    track.addEventListener('dragstart', (e) => e.preventDefault());

    set(0);
    return { track, go, index: () => idx };
  }

  KX.define('pdp-gallery', (el) => {
    const frame = el.querySelector('.kx-pdp__frame');
    const track = frame && frame.querySelector('.kx-pdp__track');
    if (!track) return;
    const slides = [...track.children];
    const rail = el.querySelector('.kx-pdp__thumbs');
    const thumbs = [...el.querySelectorAll('[data-thumb]')];
    const main = rig(track, frame.querySelector('[data-prev]'), frame.querySelector('[data-next]'), (i) => {
      thumbs.forEach((t, j) => t.setAttribute('aria-current', String(j === i)));
      const t = thumbs[i];
      if (rail && t && rail.scrollWidth > rail.clientWidth) {
        rail.scrollTo({ left: t.offsetLeft - (rail.clientWidth - t.offsetWidth) / 2, behavior: KX.reduce() ? 'auto' : 'smooth' });
      }
    });
    thumbs.forEach((t, j) => t.addEventListener('click', () => main.go(j)));

    // 放大看：第一次打开时把图搬一份进弹出层（按整屏重新挑分辨率）
    const dlg = el.querySelector('.kx-pdp__viewer');
    let big = null;
    const open = () => {
      if (!dlg || !dlg.showModal) return;
      if (!big) {
        const vt = dlg.querySelector('.kx-pdp__track');
        slides.forEach((s) => {
          const f = document.createElement('div');
          f.className = 'kx-pdp__slide';
          const img = s.querySelector('img')?.cloneNode();
          if (img) { img.sizes = '100vw'; img.loading = 'lazy'; img.removeAttribute('fetchpriority'); f.append(img); }
          vt.append(f);
        });
        const count = dlg.querySelector('.kx-pdp__count');
        big = rig(vt, dlg.querySelector('[data-prev]'), dlg.querySelector('[data-next]'), (i) => { if (count) count.textContent = `${i + 1} / ${slides.length}`; });
        dlg.addEventListener('close', () => main.go(big.index(), true));
      }
      dlg.showModal();
      big.go(main.index(), true);
      big.track.focus({ preventScroll: true });
    };
    el.querySelector('[data-zoom]')?.addEventListener('click', open);
    track.addEventListener('click', (e) => { if (e.target.closest('.kx-pdp__slide')) open(); });
  });

  // 常见邮箱的域名打错了（gmial.com / gmail.con / hotmial.co.uk）就猜一个。只看 @ 后面 —— 名字那半打错查不出来，所以邮箱要整个亮给人看。
  // 几家大邮箱：前半截按它的长短许差几个字母（5–6 个字母差 1、7 个以上差 2、更短的只认原样）；后缀只认表里的，gmail.co 也算打错；
  // yahoo / hotmail / outlook / live 各国后缀多，两个字母的国家后缀都放过。别的域名只纠 .con / .cmo 这类明摆着的后缀。
  const MAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const MAIL_ANY = /^(?:com|net|[a-z]{2}|co\.[a-z]{2}|com\.[a-z]{2})$/;
  const MAIL_HOSTS = {
    gmail: ['com'], googlemail: ['com'], icloud: ['com'], ymail: ['com'], aol: ['com'], msn: ['com'], qq: ['com'], foxmail: ['com'],
    protonmail: ['com', 'ch'], proton: ['me'], comcast: ['net'], yahoo: MAIL_ANY, hotmail: MAIL_ANY, outlook: MAIL_ANY, live: MAIL_ANY,
  };
  const MAIL_OK = new Set(['mail', 'email', 'gmx', 'web', 'zoho', 'yandex', 'fastmail', 'tutanota', 'naver', 'daum', '163', '126', 'sina', 'yeah']);
  const MAIL_TLD_FIX = {
    con: 'com', cmo: 'com', ocm: 'com', vom: 'com', xom: 'com', cpm: 'com', cim: 'com', clm: 'com', comm: 'com', coom: 'com',
    nte: 'net', ner: 'net', nett: 'net', ogr: 'org', orgg: 'org',
  };
  // 编辑距离，挨着的两个字母对调算一处（gamil → gmail 差 1）
  const dist = (a, b) => {
    const d = [];
    for (let i = 0; i <= a.length; i++) d[i] = [i];
    for (let j = 1; j <= b.length; j++) d[0][j] = j;
    for (let i = 1; i <= a.length; i++) {
      for (let j = 1; j <= b.length; j++) {
        d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
        if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + 1);
      }
    }
    return d[a.length][b.length];
  };
  const mailFix = (v) => {
    const at = v.lastIndexOf('@');
    const dom = v.slice(at + 1).toLowerCase(), dot = dom.indexOf('.');
    if (at < 1 || dot < 1) return '';
    const name = dom.slice(0, dot), tail = dom.slice(dot + 1);
    let host = MAIL_HOSTS[name] ? name : '';
    if (!host && !MAIL_OK.has(name)) {
      let best = 3;
      Object.keys(MAIL_HOSTS).forEach((h) => {
        const k = dist(name, h);
        if (k <= (h.length >= 7 ? 2 : h.length >= 5 ? 1 : 0) && k < best) { best = k; host = h; }
      });
    }
    let fixed;
    if (host) {
      const ok = MAIL_HOSTS[host];
      const good = (t) => (Array.isArray(ok) ? ok.includes(t) : ok.test(t));
      fixed = `${host}.${good(tail) ? tail : good(MAIL_TLD_FIX[tail] || '') ? MAIL_TLD_FIX[tail] : Array.isArray(ok) ? ok[0] : 'com'}`;
    } else {
      if (!MAIL_TLD_FIX[tail]) return '';
      fixed = `${name}.${MAIL_TLD_FIX[tail]}`;
    }
    return fixed === dom ? '' : `${v.slice(0, at)}@${fixed}`;
  };

  // 按钮上方确认邮箱（用户 11-04：有人结账时把邮箱打错，Hub 链接发不到、VIP 记在错的邮箱上，只能退款重来）：
  // 落地页留过邮箱就亮出来（结账页会预填它）、能改；没留过给一个框（可不填），填了同样预填。存回 ks-attribution 那一份（ksSetCheckoutEmail）。
  // 疑似打错的提示一直挂着、不拦人；只有点按钮那一刻才冒出来的（还没给人看过）挡这一次，再点就走。
  // value()：要预填的邮箱；'' = 不预填；null = 这次先别去结账（不像邮箱，或刚亮出疑似打错的提示）
  function emailBox(box) {
    const show = box.querySelector('[data-email-show]');
    const out = box.querySelector('[data-email-value]');
    const input = box.querySelector('[data-email-input]');
    const hint = box.querySelector('[data-email-hint]');
    const [pre, post = ''] = (box.dataset.suggest || 'Did you mean [email]?').split('[email]');
    let hintFor = '', timer = 0;
    const save = (v) => { if (typeof window.ksSetCheckoutEmail === 'function') window.ksSetCheckoutEmail(v); };
    const editing = () => !input.hidden;
    const clear = () => { hint.hidden = true; hint.classList.remove('is-error'); input.removeAttribute('aria-invalid'); hintFor = ''; };
    const say = (v) => {
      const fix = MAIL_RE.test(v) ? mailFix(v) : '';
      clear();
      if (!fix) return;
      const b = document.createElement('button');
      b.type = 'button';
      b.textContent = fix;
      b.addEventListener('click', () => use(fix));
      hint.replaceChildren(pre, b, post);
      hint.hidden = false;
      hintFor = v;
    };
    // 定下一个邮箱：亮出来（清空了就回到框）
    const use = (v) => {
      save(v);
      out.textContent = v;
      show.hidden = !v;
      input.hidden = !!v;
      input.value = v;
      say(v);
    };

    const em = typeof window.ksCheckoutEmail === 'function' ? window.ksCheckoutEmail() : '';
    out.textContent = em;
    show.hidden = !em;
    input.hidden = !!em;
    if (em) say(em);
    box.hidden = false;

    box.querySelector('[data-email-change]').addEventListener('click', () => {
      input.value = out.textContent;
      show.hidden = true;
      input.hidden = false;
      clear();
      input.focus();
    });
    input.addEventListener('input', () => {
      clear();
      clearTimeout(timer);
      timer = setTimeout(() => say(input.value.trim()), 700);
    });
    input.addEventListener('change', () => {
      const v = input.value.trim();
      if (!v || MAIL_RE.test(v)) save(v);
    });

    return {
      value() {
        clearTimeout(timer);
        const v = editing() ? input.value.trim() : out.textContent;
        if (!v) { save(''); return ''; }
        if (!MAIL_RE.test(v)) {
          clear();
          hint.replaceChildren(box.dataset.invalid || 'Please check your email address.');
          hint.classList.add('is-error');
          hint.hidden = false;
          input.setAttribute('aria-invalid', 'true');
          input.focus();
          return null;
        }
        save(v);
        if (mailFix(v) && hintFor !== v) { say(v); return null; }
        return v;
      },
    };
  }

  KX.define('pdp', (el) => {
    const thanks = el.querySelector('[data-thanks]');
    if (thanks && !document.body.classList.contains('kx--editor')) {
      let on = /[?&]subscribed\b/.test(location.search);
      try { if (sessionStorage.getItem('ks_sub')) { on = true; sessionStorage.removeItem('ks_sub'); } } catch (e) {}
      thanks.hidden = !on;
    }

    const form = el.querySelector('form.kx-pdp__form');
    const btn = form && form.querySelector('button[name="add"]');
    if (!form || !btn) return;
    // 落地页刚留的邮箱预填进结账页（ks-attribution 的 ksCheckoutEmail；结账页上还能改）：留了哪个邮箱，账单就发到哪个。
    // 只有购物车直达链接认 checkout[email]（/checkout?checkout[email]= 新版结账不认，10-27 在预览主题上实测）；
    // 直达链接新开购物车，来源与配置器账号标记（ksCartAttrs）跟着 attributes[…] 一起带过去。
    // 按钮上方确认过的邮箱（emailBox）优先；_ks_email 直接填它 —— 无痕模式之类存不进 localStorage 时 ksCartAttrs 里没有
    const mail = el.querySelector('[data-email]') ? emailBox(el.querySelector('[data-email]')) : null;
    // 加购打点由这里报（ks-attribution 的 ksAdded，发信引擎 Rule 1118）：提交了不一定去加购（停在邮箱提示上），所以那边按捕获阶段抓提交时跳过这张表单
    form.setAttribute('data-ks-add', 'self');
    const permalink = (id, em) => {
      if (!em) return '';
      const q = new URLSearchParams({ 'checkout[email]': em });
      const at = typeof window.ksCartAttrs === 'function' ? window.ksCartAttrs() : {};
      at._ks_email = em;
      Object.keys(at).forEach((k) => q.append(`attributes[${k}]`, at[k]));
      return `/cart/${encodeURIComponent(id)}:1?${q}`;
    };
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (btn.getAttribute('aria-busy') === 'true') return;
      const em = mail ? mail.value() : typeof window.ksCheckoutEmail === 'function' ? window.ksCheckoutEmail() : '';
      if (em === null) return;
      btn.setAttribute('aria-busy', 'true');
      const id = form.querySelector('[name="id"]').value;
      if (typeof window.ksAdded === 'function') { try { window.ksAdded(id, 1); } catch (x) {} }
      const direct = permalink(id, em);
      if (direct) { location.href = direct; return; }
      const body = new FormData();
      body.append(`updates[${id}]`, '1');
      try {
        const r = await fetch('/cart/update.js', { method: 'POST', body, headers: { Accept: 'application/json' }, credentials: 'same-origin' });
        if (!r.ok) throw new Error(r.status);
        const cart = await r.json();
        if (!cart.items || !cart.items.some((it) => String(it.variant_id) === String(id))) throw new Error('not added');
        if (typeof window.ksAttrToCart === 'function') { try { await window.ksAttrToCart(); } catch (x) {} }
        location.href = '/checkout';
      } catch (x) {
        btn.removeAttribute('aria-busy');
        HTMLFormElement.prototype.submit.call(form);
      }
    });
    // 从结账页按返回键回来时页面是缓存里那份，按钮还停在「忙」
    addEventListener('pageshow', () => btn.removeAttribute('aria-busy'));
  });
})();
